import React from "react";
import PropTypes from 'prop-types';
import classNames from "classnames";

import {
  speechBubbleTail,
  speechBubble,
  agent,
  caller,
  defaultSpeaker
} from "./styles/SpeechBubble.module.scss";

const SPEAKERS = { agent, caller };

const speakerClass = speaker => SPEAKERS[speaker] || defaultSpeaker;

const SpeechBubble = ({ speaker, children }) => {
  return (
    <div className="d-flex m-2">
      <div className={classNames(speechBubbleTail, speakerClass(speaker))} data-test-id="speech-bubble-tail" />
      <div className={classNames(speechBubble, speakerClass(speaker))} data-test-id="speech-bubble-text" >
        {children}
      </div>
    </div>
  );
};

SpeechBubble.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string
  ]).isRequired,
  speaker: PropTypes.string
};

export default SpeechBubble;
